// Material Dashboard 2 PRO React components
import { Box, Tooltip } from '@mui/material';
import { isSuperAdmin } from 'helpers/roleHelpers'; // isSuperAdmin fonksiyonunu import et

function ProductImages({ coverImage, sheetURL }) {
    const user = JSON.parse(localStorage.getItem('user')); // Kullanıcı bilgisine eriş

    const handleClick = () => {
        if (isSuperAdmin(user)) {
            window.open(sheetURL, '_blank'); // Yeni sekmede URL'i aç
        }
    };

    return (
        <Tooltip title={isSuperAdmin(user) ? "Google Sheets'i açmak için tıklayın" : ''} arrow placement="top">
            <Box
                sx={{
                    position: 'relative',
                    borderRadius: '6px',
                    overflow: 'hidden',
                    cursor: isSuperAdmin(user) ? 'pointer' : 'default',
                    border: '1px solid #EEEEEE',
                    transition: 'all 0.2s ease',
                    '&:hover': isSuperAdmin(user)
                        ? {
                              boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                              '&::after': {
                                  opacity: 1,
                              },
                          }
                        : {},
                    '&::after': {
                        content: isSuperAdmin(user) ? '""' : 'none',
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        background: 'linear-gradient(0deg, rgba(62,207,142,0.1) 0%, rgba(62,207,142,0) 100%)',
                        opacity: 0,
                        transition: 'opacity 0.2s ease',
                    },
                }}
                onClick={handleClick}
            >
                <Box
                    component="img"
                    src={coverImage}
                    alt="Template"
                    sx={{
                        width: '100%',
                        height: 'auto',
                        display: 'block',
                        aspectRatio: '3/4',
                        objectFit: 'cover',
                    }}
                />
            </Box>
        </Tooltip>
    );
}

export default ProductImages;
